import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * Wraps an admin-only route. Behavior:
 *  - while auth is loading (user === null), render nothing
 *  - if anonymous or non-admin, redirect to "/" (public results page)
 *  - otherwise, render children
 */
export default function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return null; // loading
  if (!user || user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
